import Vue from 'vue'
import Vuex from 'vuex'
import {
  getChildrenArticleById
} from '@/api/blog.js'

Vue.use(Vuex)
let blogList = []

function getBlogList(data, targetstr) {
  data.forEach(child => {
    child.name = child.name.replace(/replacestr1024/g, targetstr)
  })
  data.forEach(item => {
    item.articleList.forEach(child => {
      child.title = child.title.replace(/replacestr1024/g, targetstr)
    })
    item.articleList && (blogList = [...blogList, ...item.articleList])
    item.childrenList && getBlogList(item.childrenList, targetstr)
  })
}

export default new Vuex.Store({
  state: {
    // 平台名
    title: '',
    // 注册Icon地址
    registerIcon: '',
    // 登录Icon地址
    loginIcon: '',
    // 主页icon地址
    indexIcon: '',
    // 页头icon地址
    headerIcon: '',
    currentBlogId: '',
    menutree: [],
    menulist: [],
    aiCustomer: 0
  },
  mutations: {
    SET_TITLE: (state, title) => {
      state.title = title
    },

    SET_REGISTERICON: (state, url) => {
      state.registerIcon = url
    },
    SET_LOGINICON: (state, url) => {
      state.loginIcon = url
    },
    SET_INDEXICON: (state, url) => {
      state.indexIcon = url
    },
    SET_HEADERICON: (state, url) => {
      state.headerIcon = url
    },
    SET_MENUTREE: (state, tree) => {
      state.menutree = tree
    },
    SET_MENULIST: (state, list) => {
      state.menulist = list
    },
    SET_CURRENTBLOG: (state, id) => {
      state.currentBlogId = id
    },
    SET_AICUSTOMER: (state, aiCustomer) => {
      state.aiCustomer = aiCustomer
    }
  },
  actions: {
    async setWebInfo({
      commit
    }, data) {
      commit('SET_TITLE', data.headerName)
      commit('SET_REGISTERICON', data.registerIcon)
      commit('SET_LOGINICON', data.loginIcon)
      commit('SET_INDEXICON', data.indexIcon)
      commit('SET_HEADERICON', data.headerIcon)
      commit('SET_AICUSTOMER', data.aiCustomer)
      const resp = await getChildrenArticleById({
        id: 5
      })
      resp.data.childrenList.forEach(item => {

      })
      commit('SET_MENUTREE', resp.data.childrenList)
      await getBlogList(resp.data.childrenList, data.headerName)
      commit('SET_MENULIST', blogList)
      let link = document.createElement("link")
      link.rel = "icon"
      link.href = data.headerIcon
      document.head.appendChild(link)
      document.title = data.headerName + '-帮助中心'
    }
  },
  modules: {}
})



// // 循环101~200的数
// for (var i = 101; i <= 200; i++) {
//   // 定义一个标志，false为素数
//   var isfind = false;
//   // 循环该数字内大于2的正整数
//   for (var j = 2; j < i; j++) {
//     // 若能被这正整数取模为0，这不是素数
//     if (i % j === 0) {
//       isfind = true;
//       // 结束取整数循环
//       break;
//     }
//   }
//   // 判断标志是否是素数,是的话存起来
//   if (!isfind) {
//     console.log(i)
//   }
// }

// for (let i = 100; i <= 999; i++) {
//   // 个位
//   let a = i % 10
//   // 十位
//   let b = (i - a) % 100 / 10
//   // 百位
//   let c = (i - b * 10 - a) / 100
//   if (Math.pow(a, 3) + Math.pow(b, 3) + Math.pow(c, 3) === i) {
//     console.log(i)
//   }
// }



// function dg(i) {
//   if (i === 1) {
//     return 1
//   } else if (i === 2) {
//     return 2
//   } else {
//     return i * dg(i - 1)
//   }
// }
// console.log(dg(3))



// for (var i = 1; i <= 9; i++) {
//   var str = ''
//   for (var j = 1; j <= 9; j++) {
//     if (i >= j) {
//       var sum = i * j
//       str = str + `${i}*${j}=${sum} `
//     }

//   }
//   console.log(str)
// }